// Event keys
export const CLICK_ORDER_BOOK_PRICE = 'click_order_book_price';
export const VIEW_TRADE_PANEL = 'view_trade_panel';
export const CLICK_SWITCH_ORDER_SIDE = 'switch_order_side';
export const CLICK_SWITCH_ORDER_TYPE = 'switch_order_type';
export const CLICK_SUBMIT_BUY_BUTTON = 'click_submit_buy_button';
export const CLICK_BUY_BUTTON_CONFIRM = 'click_buy_button_confirm';
export const CLICK_SUBMIT_SELL_BUTTON = 'click_submit_sell_button';
export const CLICK_SELL_BUTTON_CONFIRM = 'click_sell_button_confirm';
export const ORDER_SEND_SUCCESS = 'order_send_success';
export const ORDER_SEND_FAIL = 'order_send_fail';
export const VIEW_INSUFFICIENT_ERROR = 'view_insufficient_error';
export const CLICK_INSUFFICIENT_CTA = 'click_insufficient_cta';
export const CLICK_SEARCH_DISCOVERY = 'click_search_discovery';
